import { MessageCircle, Phone, MessagesSquare } from "lucide-react";
import { CRISIS } from "../content/site";

const base =
  "inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-colors duration-200";

export const CrisisActions = ({ variant = "light", className = "" }) => {
  const styles =
    variant === "dark"
      ? {
          call: `${base} bg-gold text-ink hover:bg-gold-soft`,
          text: `${base} border border-cream/50 text-cream hover:bg-cream/10`,
          chat: `${base} border border-cream/50 text-cream hover:bg-cream/10`,
        }
      : {
          call: `${base} bg-sage text-cream hover:bg-sage-light`,
          text: `${base} border border-sage/30 text-sage hover:bg-sage-soft`,
          chat: `${base} border border-sage/30 text-sage hover:bg-sage-soft`,
        };
  return (
    <div className={`flex flex-wrap gap-3 ${className}`} data-testid="crisis-actions">
      <a href={CRISIS.callHref} className={styles.call} data-testid="crisis-call-988-button">
        <Phone className="h-4 w-4" aria-hidden="true" /> Call 988
      </a>
      <a href={CRISIS.textHref} className={styles.text} data-testid="crisis-text-988-button">
        <MessageCircle className="h-4 w-4" aria-hidden="true" /> Text 988
      </a>
      <a
        href={CRISIS.chatHref}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.chat}
        data-testid="crisis-chat-988-button"
      >
        <MessagesSquare className="h-4 w-4" aria-hidden="true" /> Chat with 988
      </a>
    </div>
  );
};
